import { CommonConfig } from '@domgen/dgx-fe-common';
import { AppConfig } from '../../models/config/app-config.type';

export const commonConfigFactory = (config: AppConfig): CommonConfig => ({
  catalogueStore: config.catalogueStore,
  cookiePro: config.cookiePro,
  requestAction: config.requestAction,
  whiteLabelClient: config.whiteLabelClient,
});
